module.exports = __webpack_public_path__ + "static/AJ-b29b7ccecc9aa5539505f86e89c5c2b9.jpg";